export default __webpack_public_path__ + "static/media/logo-aberto-white.5b20b9b7.svg";